import React from 'react';
import styled from 'styled-components';
import DeliveryBadge from '@catalogo/ui-americanas-desktop-svg/badge-aditional-delivery.svg';
import AttendanceBadge from '@catalogo/ui-americanas-desktop-svg/badge-aditional-attendance.svg';

interface AditionalBadgesProps {
  hasBadgeCustomCare: boolean;
  hasBadgeFastDelivery: boolean;
}

export const AditionalBadges = ({ hasBadgeCustomCare, hasBadgeFastDelivery }: AditionalBadgesProps) => {
  const concat = hasBadgeCustomCare && hasBadgeFastDelivery ? ' e ' : '';

  return hasBadgeCustomCare || hasBadgeFastDelivery ? (
    <Wrapper>
      <Icons>
        {hasBadgeFastDelivery && <DeliveryBadge />}
        {hasBadgeCustomCare && <AttendanceBadge />}
      </Icons>
      <Text>
        {hasBadgeFastDelivery && <strong>entrega no prazo</strong>}
        {concat}
        {hasBadgeCustomCare && <strong>bom atendimento pós-compra</strong>}
      </Text>
    </Wrapper>
  ) : null;
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const Icons = styled.div`
  display: flex;
  margin-right: 2px;
  align-items: center;
  position: relative;
  max-width: 38px;

  > svg {
    flex-shrink: 0;

    &:nth-child(1) {
      z-index: 1;
    }

    &:nth-child(2) {
      transform: translateX(-8px);
      z-index: 0;
    }
  }
`;

const Text = styled.span`
  font-size: 10px;

  > strong {
    color: #008000;
  }
`;
